
console.log(__BUILD_INFO__)
export function showVersionInfo() {
    const el = document.createElement('div');
    el.classList.add('version');
    const text = __BUILD_INFO__;
    el.innerHTML = text;
    const refresh = document.createElement('button');
    refresh.innerText = '🔄';
    refresh.addEventListener('click', ()=>{
        window.location.reload();
    });
    el.appendChild(refresh);
    document.body.appendChild(el)
}